import { Link } from "react-router-dom";
import React from "react";


const Nav = () =>{
    return(
        <div>


<nav class="navbar navbar-expand-lg bg-body-tertiary fixed-top">
  <div class="container-fluid mx-5">
    <a class="navbar-brand fs-2" href="#">Furni.</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <Link to="/Home" class="nav-link active px-4" aria-current="page" >Home</Link>
        </li>
        <li class="nav-item">
          <Link to="/Product" class="nav-link px-4" aria-current="page">Product</Link>
        </li>
        <li class="nav-item">
          <Link to="/About" class="nav-link px-4" aria-current="page">About Us </Link>
        </li>
        <li class="nav-item">
          <Link to="/Services" class="nav-link px-4" aria-current="page">Services</Link>
        </li>
        <li class="nav-item">
          <Link to="/Blog" class="nav-link px-4" aria-current="page">Blog</Link>
        </li>
        <li class="nav-item">
          <Link to="/Contact" class="nav-link px-4" aria-current="page">Contact Us</Link>
        </li>
       
      </ul>
    
    </div>
  </div>
</nav>
        
        </div>
    )
}

export default Nav;